export enum SideBarTab {
  Patients = "patients",
  Questionnaires = "questionnaire-templates",
  WardRounds = "ward-round-templates",
  Cares = "care-templates",
}
